import app from './../index';

export default class VossArtikelBild {

  constructor() {
    this.template = "<img ng-src='{{artikelLink}}' />";
    this.restrict = "E";
    this.scope = {
      artikelId: "@"
    };
  }

  //link(scope, element, attributes)
  link(scope) {

    scope.$watch('artikelId', function(newValue) {
      if (newValue) {
        scope.artikelLink = app.serviceBase + "/artikel/" + newValue + "/bild";
      }

    });
  }
}



/** WEBPACK FOOTER **
 ** ./public/app/components/VossArtikelBild.js
 **/